import { BUTTON_MIN_HEIGHT, ButtonSize, IconButton } from '@ardoq/button';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Header4 } from '@ardoq/typography';

export type SidePanelHeaderProps = {
  iconName: IconName;
  title: string;
  closeLabel: string;
  onClose: VoidFunction;
};

const CLOSE_BUTTON_SIZE = ButtonSize.REGULAR;
const LEADING_ICON_BOX_SIZE = BUTTON_MIN_HEIGHT[CLOSE_BUTTON_SIZE];

export const SidePanelHeader = ({
  iconName,
  title,
  closeLabel,
  onClose,
}: SidePanelHeaderProps) => (
  <FlexBox align="center" gap="small" paddingX="medium" paddingY="small">
    <FlexBox
      align="center"
      justify="center"
      flexShrink={0}
      minWidth={LEADING_ICON_BOX_SIZE}
      minHeight={LEADING_ICON_BOX_SIZE}
    >
      <Icon
        iconName={iconName}
        iconSize={IconSize.SMALL}
        color={colors.iconAction}
      />
    </FlexBox>
    <FlexBox flexGrow={1} minWidth="0">
      <Header4>{title}</Header4>
    </FlexBox>
    <IconButton
      iconName={IconName.CLOSE}
      buttonSize={CLOSE_BUTTON_SIZE}
      onClick={onClose}
      label={closeLabel}
    />
  </FlexBox>
);
